export class BaseError extends Error {
    cause: unknown;
    constructor(message?: string, options?: { cause?: unknown }) {
        // @ts-ignore
        super(message, options);
        this.cause = options?.cause;
    }
}
